export default __webpack_public_path__ + "static/media/briefcase.7ba4d075.svg";